module.exports = __webpack_public_path__ + "img/home.2db89e30.svg";